import {FC, memo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {IAttachmentData} from '@kcast-fe/core';

import {RenderVideo} from './components';

interface IProps {
  videos: Array<IAttachmentData>;
}

const RenderVideoListFC: FC<IProps> = ({videos}) => {
  return videos.length > 0 ? (
    <Flex flexDirection={'column'} gap={'24px'}>
      {videos.map((attachment) => (
        <Box key={attachment.url} data-testid={'attached-video'}>
          <RenderVideo attachment={attachment} />
        </Box>
      ))}
    </Flex>
  ) : (
    <></>
  );
};

export const RenderVideoList = memo(RenderVideoListFC);
